var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('var',{attrs:{"data-mark":""}}),_c('img',{staticClass:"image",attrs:{"src":_vm.randomImage}}),_c('h1',[_vm._v("Coming Soon.")]),_c('h2',[_vm._v("即使如此，零風還是")])])}
var staticRenderFns = []

export { render, staticRenderFns }